import { Component, OnInit } from '@angular/core';
import { HxPagedListDirective } from 'hx-components';
import { FaqModel, HxFaqService, HxSafeHtmlPipe, HxUiLabelPipe, PagedList, toRouterQueryParams } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { takeUntil } from 'rxjs/operators';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';
import Timeout = NodeJS.Timeout;

@Component({
    selector: 'hc-faq-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, NzInputDirective, FormsModule, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, HxUiLabelPipe, HxSafeHtmlPipe, TranslocoPipe]
})
export class FaqsListComponent extends HxPagedListDirective<FaqModel> implements OnInit {

  params: { limit?: number; page?: number; query?: string } = {};
  private timeoutId?: Timeout;

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected notification: NzNotificationService,
    private tr: TranslocoService,
    private faqService: HxFaqService
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit(): void {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        this.params.query = paramMap.get('query') ?? undefined;
        super.load(paramMap);
      });
  }

  applyFilters(delay?: number) {
    if (delay) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => this.navigate(), delay);
    } else {
      this.navigate();
    }
  }

  remove(id: number) {
    this.faqService.removeFaq(id).then(() => {
      this.loadData();
      this.notification.success(this.tr.translate('nav.Faq'), this.tr.translate('nt.dataRemoved'));
    });
  }

  private navigate() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: toRouterQueryParams(this.params),
    });
  }

  protected loadList(): Promise<PagedList<FaqModel>> {
    this.params.page = this.page;
    this.params.limit = this.limit;
    return this.faqService.getFaqs(this.params);
  }
}
